
import React, { Fragment } from 'react';

import SelectOrgUnit from '@usas/ui-web/components/selectOrgUnit/SelectOrgUnit';

import useOrgUnitSelection from './UseOrgUnitSelection';

const OrgUnitSelection = () => {
  const { NavLinks, SSRP_ROLE_GROUP_ID, TAXONOMIES, SCOPE } = useOrgUnitSelection();

  return (
    <Fragment>
      <SelectOrgUnit
        pageTitle={'Safe Sport Recognition Program'}
        navLink={NavLinks.SAFE_SPORT_PROGRAM_LEVEL}
        roleGroupId={SSRP_ROLE_GROUP_ID}
        getFunction={() => { }}
        TAXONOMIES={TAXONOMIES}
        SCOPE={SCOPE} />
    </Fragment>
  );
};

export default OrgUnitSelection;